export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/next.237b7a58.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};